import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// CLIENT
const ClientListPage = lazy(() => import('src/pages/management/client/list'));
const ClientNew = lazy(() => import('src/pages/management/client/new'));
const ClientEditPage = lazy(() => import('src/pages/management/client/edit'));
const ClientAccountPage = lazy(() => import('src/pages/management/client/account'));
const DriverLicenseProcessingPage = lazy(() => import('src/pages/management/client/driver-license-processing'));
// EMPLOYEE
const EmployeeListPage = lazy(() => import('src/pages/management/employee/list'));
const EmployeeNew = lazy(() => import('src/pages/management/employee/new'));
const EmployeeEditPage = lazy(() => import('src/pages/management/employee/edit'));

export const managementRoutes = [
  {
    path: 'management',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'client',
        children: [
          { element: <ClientListPage />, index: true },
          { path: 'list', element: <ClientListPage /> },
          { path: 'new', element: <ClientNew /> },
          { path: 'driver-license-processing', element: <DriverLicenseProcessingPage /> },
          { path: ':id/edit', element: <ClientEditPage /> },
          { path: 'account', element: <ClientAccountPage /> },
        ],
      },
      {
        path: 'employee',
        children: [
          { element: <EmployeeListPage />, index: true },
          { path: 'list', element: <EmployeeListPage /> },
          { path: 'new', element: <EmployeeNew /> },
          { path: ':id/edit', element: <EmployeeEditPage /> },
        ],
      },
    ],
  },
];
